import { render } from "./Collect.vue?vue&type=template&id=2c861ee1&scoped=true"
import script from "./Collect.vue?vue&type=script&lang=js"
export * from "./Collect.vue?vue&type=script&lang=js"

import "./Collect.vue?vue&type=style&index=0&id=2c861ee1&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c861ee1"]])

export default __exports__